/** Session key: odometer mileage (integer string) when cart was last priced. */
export const CART_PRICED_ODOMETER_SESSION_KEY = 'cartPricedOdometerMiles';

function normalizeVehicleMileageToNumber(mileage: unknown): number | null {
  if (mileage === undefined || mileage === null) return null;
  const s = String(mileage).replace(/,/g, '');
  const n = Math.round(Number(s));
  if (!Number.isFinite(n) || n < 0) return null;
  return n;
}

/**
 * Snapshot current session vehicle mileage as the odometer used for the last cart pricing.
 * Call whenever cart is persisted to sessionStorage.
 */
export function snapshotCartPricedOdometerFromSessionVehicle(): void {
  if (typeof sessionStorage === 'undefined') return;
  try {
    const raw = sessionStorage.getItem('vehicle');
    if (!raw) return;
    const v = JSON.parse(raw) as { mileage?: unknown };
    const n = normalizeVehicleMileageToNumber(v?.mileage);
    if (n !== null) {
      sessionStorage.setItem(CART_PRICED_ODOMETER_SESSION_KEY, String(n));
    }
  } catch {
    /* ignore */
  }
}

export function removeCartPricedOdometerSnapshot(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(CART_PRICED_ODOMETER_SESSION_KEY);
}

export function readCartPricedOdometerSnapshot(): number | null {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(CART_PRICED_ODOMETER_SESSION_KEY);
    if (raw == null || raw === '') return null;
    const n = Math.round(Number(raw));
    return Number.isFinite(n) && n >= 0 ? n : null;
  } catch {
    return null;
  }
}
